import { useFeatureGate } from '@statsig/expo-bindings';
import { Redirect } from 'expo-router';

import { FeatureFlags } from '../../../feature-flags/FeatureFlags';
import { Membership } from '../../../settings/components/Membership';

const MembershipPage = () => {
    const { value: enableBillingSettings } = useFeatureGate(
        FeatureFlags.ENABLE_BILLING_SETTINGS,
    );

    if (!enableBillingSettings) {
        return <Redirect href="/settings" />;
    }

    return <Membership />;
};

export default MembershipPage;
